import { render, staticRenderFns } from "./ProductRegister.vue?vue&type=template&id=331dfe71&"
import script from "./ProductRegister.vue?vue&type=script&lang=js&"
export * from "./ProductRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports